import { cn } from '@/lib/utils';
import { NavLink, NavLinkProps } from 'react-router-dom';

interface EnhancedNavLinkProps extends NavLinkProps {
  className?: string;
}

const EnhancedNavLink: React.FC<EnhancedNavLinkProps> = ({ className, ...props }) => {
  return (
    <NavLink
      {...props}
      className={({ isActive }) =>
        cn('text-[#747479] px-2 py-3 flex items-center gap-3 rounded-md', { ['bg-[#ebebee] text-[#111112]']: isActive }, className)
      }
    />
  );
};

export default EnhancedNavLink;
